export default "__VITE_ASSET__DYMjezpE__"